import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getReleaseVersion,
  getUpdateReleaseVersionValidations,
  getUpdateSCVersionAudioValidations,
  getUpdateVersionSongValidations,
} from 'app/store/Releases/selectors';
import { useCallback, useEffect, useState } from 'react';
import {
  fetchUpdateReleaseVersionValidationsEffect,
  fetchUpdateSCVersionAudioValidationsEffect,
  fetchUpdateVersionSongValidationsEffect,
} from 'app/store/Releases/effects';

export const useValidations = () => {
  const dispatch = useAppDispatch();
  const releaseVersion = useAppSelector(getReleaseVersion);
  const versionSongValidations = useAppSelector(
    getUpdateVersionSongValidations
  );
  const versionValidations = useAppSelector(getUpdateReleaseVersionValidations);
  const updateVersionAudioValidations = useAppSelector(
    getUpdateSCVersionAudioValidations
  );

  const [validationsLoading, setValidationsLoading] = useState(false);

  const fetchValidations = useCallback(async () => {
    if (releaseVersion && (!versionSongValidations || !versionValidations)) {
      setValidationsLoading(true);
      if (!versionValidations) {
        await dispatch(fetchUpdateReleaseVersionValidationsEffect());
      }
      if (!versionSongValidations) {
        await dispatch(fetchUpdateVersionSongValidationsEffect());
      }
      setValidationsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [releaseVersion, dispatch]);

  const fetchAudioDetailsValidations = async (audioGuid: string) => {
    await dispatch(
      fetchUpdateSCVersionAudioValidationsEffect({
        audioGuid,
      })
    );
  };

  useEffect(() => {
    fetchValidations();
  }, [fetchValidations]);

  return {
    validationsLoading,
    versionSongValidations,
    versionValidations,
    updateVersionAudioValidations,
    fetchAudioDetailsValidations,
  };
};
